import { BASE_URL } from "config";
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import usersTableData from "./data/usersTableData";
import TextField from "@mui/material/TextField";
import { useMaterialUIController, setDirection } from "context";
import MDButton from "components/MDButton";
import AddUserModal from "../../components/AddUserModal"; // تأكد من المسار الصحيح
import AddIcon from "@mui/icons-material/Add";
import { Height } from "@mui/icons-material";
import { width } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import RowsPerPageSelector from "components/RowsPerPageSelector";
import Permissions from "layouts/role-permission/Permissions";

function Users() {
  const [controller, dispatch] = useMaterialUIController();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [permessionFormIsOpen, setPermessionFormIsOpen] = useState(false);

  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
  };

  const handleEnvokePermissions = (user) => {
    setCurrentUser(user);
    setPermessionFormIsOpen(true); // ← فتح مودال الصلاحيات هنا
  };

  useEffect(() => {
    setDirection(dispatch, "rtl");
    fetchUsers();
    return () => setDirection(dispatch, "ltr");
  }, []);
  // get all users
  const fetchUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/users", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setUsers(data.data || []);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const { columns, rows } = usersTableData(
    users,
    handleEditClick,
    handleEnvokePermissions,
    fetchUsers
  );

  const filteredRows = rows.filter(
    (row) =>
      row.author.props.name.toLowerCase().includes(search.toLowerCase()) ||
      row.author.props.email.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث
  }, [search, rowsPerPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddUserModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchUsers}
        initialData={currentUser}
      />
      <Permissions
        open={permessionFormIsOpen}
        onClose={() => {
          setPermessionFormIsOpen(false);
          setCurrentUser(null);
        }}
        user={currentUser}
      />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة المستخدمين
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              مستخدم جديد
            </MDButton>
          </MDBox>

          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="300px"
              py={6}
            >
              <CircularProgress size={60} sx={{ color: "#ca9937" }} />
            </Box>
          ) : (
            <>
              <MDBox pt={3} px={2}>
                <TextField
                  fullWidth
                  label="بحث بالاسم أو البريد"
                  variant="outlined"
                  size="small"
                  sx={{ mb: 3 }}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <MDBox mb={2} display="flex">
                  <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
                </MDBox>
                <DataTable
                  table={{ columns, rows: paginatedRows }}
                  isSorted={false}
                  showTotalEntries={true}
                  noEndBorder
                  sx={{
                    "& .MuiTable-root": { minWidth: 1000 },
                    "& .MuiTableCell-root": {
                      py: 1.5,
                      borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                    },
                    "& .MuiTableHead-root": {
                      backgroundColor: (theme) => theme.palette.grey[100],
                    },
                  }}
                />

                {/* أزرار التحكم في الصفحات */}
                <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
                  <MDButton
                    onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                    disabled={page === 0}
                    sx={{
                      background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                      color: "white",
                      borderRadius: "50%",
                      width: "50px",
                      height: "50px",
                      minWidth: "50px",
                      mx: 1,
                      "&:hover": {
                        background: "linear-gradient(90deg, #b6842f, #d39d45)",
                      },
                    }}
                  >
                    <ArrowBackIcon />
                  </MDButton>

                  <MDTypography
                    variant="button"
                    color="text"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mx: 3,
                      fontWeight: "bold",
                    }}
                  >
                    الصفحة {page + 1} من {Math.ceil(filteredRows.length / rowsPerPage)}
                  </MDTypography>

                  <MDButton
                    onClick={() =>
                      setPage((prev) =>
                        (prev + 1) * rowsPerPage >= filteredRows.length ? prev : prev + 1
                      )
                    }
                    disabled={(page + 1) * rowsPerPage >= filteredRows.length}
                    sx={{
                      background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                      color: "white",
                      borderRadius: "50%",
                      width: "50px",
                      height: "50px",
                      minWidth: "50px",
                      mx: 1,
                      "&:hover": {
                        background: "linear-gradient(90deg, #b6842f, #d39d45)",
                      },
                    }}
                  >
                    <ArrowForwardIcon />
                  </MDButton>
                </MDBox>
              </MDBox>
            </>
          )}
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default Users;
